import { getType } from "typesafe-actions";
import { NavigateActions, navigateAction, clearNavigateAction } from "../actions";

export interface NavigateState {
  path?: string;
}

const defaultState: NavigateState = {};

export const reducer = (state = defaultState, action: NavigateActions): NavigateState => {
  switch (action.type) {
    case getType(navigateAction): {
      return { path: action.payload };
    }
    case getType(clearNavigateAction): {
      return {};
    }
    default:
      return state;
  }
};
